export enum MeetingStatusEnum {
    NotAMeeting = 0,
    Meeting = 1,
    Received = 2,
    Cancelled = 4,
    Other = 8
}
